<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="container grid grid-cols-12 gap-y-[30px] pb-12 md:gap-x-[30px]">
    <div class="col-span-12 mt-12">
      <CiSkeleton-Item class="mb-1 h-[38px] w-[70%]" />
    </div>
    <div class="col-span-12 md:col-span-8">
      <CiSkeleton-Item class="h-[70px] w-full" />
    </div>

    <div class="col-span-12 lg:col-span-6">
      <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
      <CiSkeleton-Item class="mb-4 h-14 w-full" />
      <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
      <CiSkeleton-Item class="mb-4 h-14 w-full" />
      <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
      <CiSkeleton-Item class="mb-4 h-14 w-full" />
      <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
      <CiSkeleton-Item class="mb-4 h-14 w-full" />
      <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
      <CiSkeleton-Item class="h-14 w-full" />
    </div>
    <div class="col-span-12 lg:col-span-6">
      <div class="flex h-full flex-col">
        <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
        <CiSkeleton-Item class="h-full min-h-[154px]" />
      </div>
    </div>

    <div class="col-span-12">
      <CiSkeleton-Item class="mb-6 block h-5 w-[30%]" />
      <CiSkeleton-Item class="h-[70px] w-full" />
    </div>

    <div class="col-span-12 md:col-span-6 md:mt-0 lg:col-span-3 lg:col-start-4">
      <CiSkeleton-Item class="h-10 w-full" />
    </div>
    <div class="col-span-12 md:col-span-6 lg:col-span-3">
      <CiSkeleton-Item class="h-10 w-full" />
    </div>
  </div>
</template>
